import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { CargueArchivoBaseBeneficiariosComponent } from './CargueArchivoBaseBeneficiarios.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'CargueArchivoBaseBeneficiarios',
        component: CargueArchivoBaseBeneficiariosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CargueArchivoBaseBeneficiarios',
          nombreFormulario : 'Cargue Archivo Base y Beneficiarios'
        } 
    }
];

@NgModule({
    declarations: [
        CargueArchivoBaseBeneficiariosComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        CargueArchivoBaseBeneficiariosComponent
    ],
    bootstrap: [CargueArchivoBaseBeneficiariosComponent]
})

export class CargueArchivoBaseBeneficiariosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CargueArchivoBaseBeneficiarios/CargueArchivoBaseBeneficiarios.module.ts